/* Rastrear pedido (sections/rastrear-pedido.liquid).
   Manda CPF/CNPJ + código do cliente para o robô de atendimento (data-endpoint)
   e mostra a situação da entrega. Nenhum dado fica guardado no navegador. */
(function () {
  'use strict';

  function soDigitos(v) {
    return (v || '').replace(/\D/g, '');
  }

  /* 000.000.000-00 ou 00.000.000/0000-00, conforme o tamanho. */
  function mascaraDocumento(v) {
    var d = soDigitos(v).slice(0, 14);
    if (d.length <= 11) {
      return d
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return d
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  }

  function dinheiro(valor) {
    return 'R$ ' + Number(valor).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* "ROTA NORTE" -> "Rota Norte" */
  function capitalizar(t) {
    return (t || '').toLowerCase().replace(/(^|\s)\S/g, function (l) { return l.toUpperCase(); });
  }

  /* "15/10/2026" -> Date, pra saber se a saída já passou. */
  function dataBr(t) {
    var m = /^(\d{2})\/(\d{2})\/(\d{4})/.exec(t || '');
    return m ? new Date(Number(m[3]), Number(m[2]) - 1, Number(m[1])) : null;
  }

  function el(tag, classe, texto) {
    var e = document.createElement(tag);
    if (classe) e.className = classe;
    if (texto !== undefined) e.textContent = texto;
    return e;
  }

  function aviso(tipo, titulo, texto) {
    var caixa = el('div', 'rastreio__aviso rastreio__aviso--' + tipo);
    caixa.appendChild(el('p', 'rastreio__aviso-titulo', titulo));
    if (texto) caixa.appendChild(el('p', 'rastreio__aviso-texto', texto));
    return caixa;
  }

  /* Um produto da compra: foto (quando a loja tem), nome, variação e quantidade.
     Com link pra página do produto quando ele está na loja online. */
  function linhaProduto(p) {
    var linha = el(p.url ? 'a' : 'div', 'rastreio__produto');
    if (p.url) {
      linha.href = p.url;
      linha.target = '_blank';
      linha.rel = 'noopener';
    }
    var foto = el('div', 'rastreio__produto-foto');
    if (p.imagem) {
      var img = document.createElement('img');
      img.src = p.imagem + (p.imagem.indexOf('?') === -1 ? '?' : '&') + 'width=160';
      img.alt = p.nome;
      img.loading = 'lazy';
      img.width = 80;
      img.height = 80;
      foto.appendChild(img);
    }
    linha.appendChild(foto);
    var texto = el('div', 'rastreio__produto-texto');
    texto.appendChild(el('p', 'rastreio__produto-nome', (p.quantidade > 1 ? p.quantidade + 'x ' : '') + p.nome));
    if (p.variante) texto.appendChild(el('p', 'rastreio__produto-variante texto-suave', p.variante));
    linha.appendChild(texto);
    return linha;
  }

  function cartaoCompra(c) {
    var hoje = new Date();
    hoje.setHours(0, 0, 0, 0);
    var card = el('article', 'rastreio__compra');
    card.appendChild(el('p', 'rastreio__compra-topo', 'Compra de ' + c.data + ' · ' + dinheiro(c.valor)));
    if (c.produtos && c.produtos.length) {
      var produtos = el('div', 'rastreio__produtos');
      c.produtos.forEach(function (p) { produtos.appendChild(linhaProduto(p)); });
      card.appendChild(produtos);
    }

    if (!c.carga) {
      card.classList.add('rastreio__compra--aguardando');
      /* Previsão calculada pelo robô com a região do cliente (roteiro do
         caminhão). Sem ela (região fora do roteiro), fica o texto de espera. */
      if (c.previsaoEntrega) {
        card.appendChild(el('p', 'rastreio__compra-status', 'Previsão de entrega: ' + c.previsaoEntrega));
        card.appendChild(el('p', 'rastreio__compra-detalhe texto-suave',
          'Entrega entre 08h e 18h. Assim que o pedido entrar numa carga, a data de saída aparece aqui.'));
        return card;
      }
      card.appendChild(el('p', 'rastreio__compra-status', 'Pedido confirmado, aguardando programação de entrega'));
      card.appendChild(el('p', 'rastreio__compra-detalhe texto-suave',
        'Assim que ele entrar numa carga de entrega, a data de saída aparece aqui.'));
      return card;
    }

    var saida = dataBr(c.carga.saidaPrevista);
    var jaSaiu = saida && saida < hoje;
    var eHoje = saida && saida.getTime() === hoje.getTime();
    card.classList.add(jaSaiu ? 'rastreio__compra--saiu' : 'rastreio__compra--programado');

    var status = jaSaiu
      ? 'Saiu para entrega em ' + c.carga.saidaPrevista
      : eHoje
        ? 'Sai para entrega hoje'
        : c.carga.saidaPrevista
          ? 'Saída prevista para ' + c.carga.saidaPrevista
          : 'Programado para entrega';
    card.appendChild(el('p', 'rastreio__compra-status', status));
    /* Horario da rota, dentro do card, sempre que a compra esta numa carga.
       O "i" ao lado abre a explicacao completa (fica oculta ate o clique). */
    var horario = el('p', 'rastreio__compra-horario');
    horario.appendChild(el('span', '', 'Entrega entre 08h e 18h'));
    var info = el('button', 'rastreio__info', 'i');
    info.type = 'button';
    info.setAttribute('aria-label', 'Mais informações sobre o horário da entrega');
    info.setAttribute('aria-expanded', 'false');
    horario.appendChild(info);
    card.appendChild(horario);
    var explicacao = el('p', 'rastreio__info-texto texto-pequeno',
      'A entrega é feita em horário comercial: pode chegar a qualquer momento entre 08h e 18h do ' +
      'dia de saída. Não é possível acompanhar o entregador em tempo real. Se não chegar até as ' +
      '18h, a entrega passa para o próximo dia de entrega da sua região.');
    explicacao.hidden = true;
    card.appendChild(explicacao);
    info.addEventListener('click', function () {
      explicacao.hidden = !explicacao.hidden;
      info.setAttribute('aria-expanded', String(!explicacao.hidden));
    });

    var detalhes = 'Carga ' + c.carga.numero + (c.carga.rota ? ' · ' + capitalizar(c.carga.rota) : '');
    card.appendChild(el('p', 'rastreio__compra-detalhe texto-suave', detalhes));
    return card;
  }

  function mostrar(resultado, conteudo) {
    resultado.innerHTML = '';
    resultado.appendChild(conteudo);
    resultado.hidden = false;
    resultado.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  /* ------------------------------------------------- Chat (Hablla) -- */

  /* O webchat da Hablla não tem API pública para abrir nem para mandar
     mensagem: o botão clica no ícone do widget e escreve no campo dele como
     se fosse a pessoa. É a parte que mais pode quebrar se a Hablla mudar o
     widget; aí o botão cai no WhatsApp (data-whatsapp). */
  function campoDoChat() {
    var campos = document.querySelectorAll('#hablla-webchat input.hablla-webchat--input');
    for (var i = 0; i < campos.length; i++) {
      /* O campo da conversa é o "Digite sua mensagem..."; o sem reticências é
         de uma janela interna do widget. */
      if (/\.\.\.$/.test(campos[i].placeholder) && campos[i].getClientRects().length) return campos[i];
    }
    return null;
  }

  /* O campo é controlado por React: atribuir .value direto não chega no
     estado dele. Pelo setter nativo + evento input, o React vê a mudança, e o
     Enter dispara o envio que o widget já faz. */
  function escreverNoChat(campo, texto) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    campo.focus();
    setter.call(campo, texto);
    campo.dispatchEvent(new Event('input', { bubbles: true }));
    setTimeout(function () {
      campo.dispatchEvent(new KeyboardEvent('keydown', { key: 'Enter', code: 'Enter', keyCode: 13, which: 13, bubbles: true }));
    }, 200);
  }

  function abrirChat(texto, reserva) {
    if (!campoDoChat()) {
      var icone = document.querySelector('#hablla-webchat .hablla-webchat--bubble, #hablla-webchat .hablla-webchat--tab');
      if (!icone) {
        reserva();
        return;
      }
      icone.click();
    }
    /* Espera o widget abrir (e conectar) antes de escrever. Se não abrir, o
       chat fica como está: a pessoa ainda pode digitar. */
    var inicio = Date.now();
    (function esperar() {
      var campo = campoDoChat();
      if (campo) {
        escreverNoChat(campo, texto);
        return;
      }
      if (Date.now() - inicio < 10000) setTimeout(esperar, 250);
    })();
  }

  function iniciar(secao) {
    var form = secao.querySelector('[data-rastreio-form]');
    if (!form) return;
    var documento = secao.querySelector('[data-rastreio-documento]');
    var codigo = secao.querySelector('[data-rastreio-codigo]');
    var semNota = secao.querySelector('[data-rastreio-sem-nota]');
    var campoCodigo = secao.querySelector('[data-rastreio-campo-codigo]');
    var email = secao.querySelector('[data-rastreio-email]');
    var campoEmail = secao.querySelector('[data-rastreio-campo-email]');
    var botao = secao.querySelector('[data-rastreio-botao]');
    var resultado = secao.querySelector('[data-rastreio-resultado]');
    var endpoint = secao.getAttribute('data-endpoint');

    /* "Fale com a gente pelo chat": abre o chat já perguntando da entrega,
       com os dados que a pessoa digitou aqui, para o robô consultar direto. */
    var botaoChat = secao.querySelector('[data-rastreio-chat]');
    if (botaoChat) {
      botaoChat.addEventListener('click', function () {
        var doc = soDigitos(documento.value);
        var cod = semNota.checked ? '' : soDigitos(codigo.value);
        var mail = semNota.checked && email ? email.value.trim() : '';
        var texto = 'Olá! Quero saber a previsão de entrega do meu pedido.';
        if (doc.length === 11 || doc.length === 14) texto += ' CPF/CNPJ: ' + doc + '.';
        if (cod.length >= 4) texto += ' Código do cliente: ' + cod + '.';
        else if (mail) texto += ' E-mail da compra: ' + mail + '.';
        abrirChat(texto, function () {
          var wpp = botaoChat.getAttribute('data-whatsapp');
          if (wpp) window.open('https://wa.me/' + wpp + '?text=' + encodeURIComponent(texto), '_blank', 'noopener');
        });
      });
    }

    documento.addEventListener('input', function () {
      documento.value = mascaraDocumento(documento.value);
    });
    codigo.addEventListener('input', function () {
      codigo.value = soDigitos(codigo.value).slice(0, 8);
    });
    /* Sem nota: troca o código do cliente pelo e-mail da compra. */
    semNota.addEventListener('change', function () {
      campoCodigo.hidden = semNota.checked;
      if (campoEmail) campoEmail.hidden = !semNota.checked;
      (semNota.checked && email ? email : codigo).focus();
    });

    var imagemAbrirBotao = secao.querySelector('[data-rastreio-imagem-abrir]');
    var lightbox = secao.querySelector('[data-rastreio-imagem-lightbox]');
    if (imagemAbrirBotao && lightbox) {
      var fecharLightbox = function () {
        if (lightbox.hidden) return;
        lightbox.hidden = true;
        document.body.classList.remove('sem-scroll');
        imagemAbrirBotao.focus();
      };
      imagemAbrirBotao.addEventListener('click', function () {
        lightbox.hidden = false;
        document.body.classList.add('sem-scroll');
      });
      Array.prototype.slice.call(lightbox.querySelectorAll('[data-rastreio-imagem-fechar]')).forEach(function (el) {
        el.addEventListener('click', fecharLightbox);
      });
      document.addEventListener('keydown', function (evento) {
        if (evento.key === 'Escape') fecharLightbox();
      });
    }

    form.addEventListener('submit', function (evento) {
      evento.preventDefault();
      var doc = soDigitos(documento.value);
      var cod = semNota.checked ? '' : soDigitos(codigo.value);
      var mail = semNota.checked && email ? email.value.trim() : '';

      if (doc.length !== 11 && doc.length !== 14) {
        mostrar(resultado, aviso('erro', 'Confira o CPF ou CNPJ', 'O CPF tem 11 números e o CNPJ tem 14.'));
        documento.focus();
        return;
      }
      if (!semNota.checked && cod.length < 4) {
        mostrar(resultado, aviso('erro', 'Informe o código do cliente',
          'São os 6 dígitos no final do seu nome, na nota fiscal. Se ainda não recebeu a nota, marque a opção abaixo do campo.'));
        codigo.focus();
        return;
      }
      if (semNota.checked && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
        mostrar(resultado, aviso('erro', 'Informe o e-mail da compra',
          'Use o mesmo e-mail que você colocou na compra pelo site.'));
        if (email) email.focus();
        return;
      }

      botao.disabled = true;
      botao.setAttribute('aria-busy', 'true');
      mostrar(resultado, aviso('info', 'Consultando seu pedido…'));

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
        body: JSON.stringify({ documento: doc, codigo: cod, email: mail })
      })
        .then(function (r) {
          return r.json().catch(function () { return { ok: false, erro: 'indisponivel' }; });
        })
        .then(function (dados) {
          if (!dados.ok) {
            if (dados.erro === 'muitas_tentativas') {
              mostrar(resultado, aviso('erro', 'Muitas tentativas seguidas',
                'Por segurança, aguarde alguns minutos e tente de novo.'));
            } else if (dados.erro === 'documento_invalido') {
              mostrar(resultado, aviso('erro', 'Confira o CPF ou CNPJ', 'O CPF tem 11 números e o CNPJ tem 14.'));
            } else {
              mostrar(resultado, aviso('erro', 'Não conseguimos consultar agora',
                'Tente de novo em alguns minutos ou fale com a gente pelo chat.'));
            }
            return;
          }

          if (dados.situacao === 'compras') {
            var lista = el('div', 'rastreio__compras');
            lista.appendChild(el('p', 'rastreio__compras-titulo',
              dados.compras.length > 1 ? 'Suas compras dos últimos 60 dias' : 'Sua compra'));
            dados.compras.forEach(function (c) { lista.appendChild(cartaoCompra(c)); });
            mostrar(resultado, lista);
          } else if (dados.situacao === 'nao_processado') {
            /* Previsão calculada pelo robô a partir do dia da compra; vem vazia se já passou. */
            mostrar(resultado, aviso('info', 'Seu pedido está sendo processado',
              'Sua compra de ' + dados.compradoEm.join(' e ') + ' ainda está em processamento.' +
              (dados.previsao ? ' Previsão de entrega: ' + dados.previsao + ', das 08h às 18h.' : '')));
          } else if (dados.situacao === 'processado_aguardando') {
            mostrar(resultado, dados.previsao
              ? aviso('info', 'Previsão de entrega: ' + dados.previsao,
                'Seu pedido já foi processado. A entrega é feita das 08h às 18h. Assim que o pedido ' +
                'entrar numa carga, a data de saída aparece aqui.')
              : aviso('info', 'Pedido confirmado, aguardando programação de entrega',
                'Seu pedido já foi processado e está aguardando entrar numa carga de entrega. Assim que ' +
                'entrar, a data de saída aparece aqui. A entrega é feita em horário comercial, das 08h às 18h.'));
          } else if (dados.situacao === 'processado_sem_entrega') {
            mostrar(resultado, aviso('erro', 'Não encontramos a entrega com esse código',
              'Seu pedido do site já foi processado. Confira o código do cliente na nota fiscal ' +
              '(6 dígitos no final do seu nome) e tente de novo.'));
          } else if (semNota.checked) {
            mostrar(resultado, aviso('erro', 'Não encontramos pedido com esses dados',
              'Confira o CPF ou CNPJ e o e-mail usado na compra pelo site. A consulta mostra compras dos últimos 60 dias.'));
          } else {
            mostrar(resultado, aviso('erro', 'Não encontramos pedido com esses dados',
              'Confira o CPF ou CNPJ e o código do cliente. A consulta mostra compras dos últimos 60 dias.'));
          }
        })
        .catch(function () {
          mostrar(resultado, aviso('erro', 'Não conseguimos consultar agora',
            'Tente de novo em alguns minutos ou fale com a gente pelo chat.'));
        })
        .finally(function () {
          botao.disabled = false;
          botao.removeAttribute('aria-busy');
        });
    });
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-rastreio]').forEach(iniciar);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', iniciarTodas)
    : iniciarTodas();

  document.addEventListener('shopify:section:load', function (evento) {
    var secao = evento.target.querySelector('[data-rastreio]');
    if (secao) iniciar(secao);
  });
})();
